import React from "react";
import { Typography } from "@mui/material";
import EditButton from "../input/button/EditButton";
import { ReactComponent as CloseIcon } from "../../assets/icons/close_black_24dp.svg";
import { useSelector } from "react-redux";
import { DEFAULT_LABEL_COLOR } from "../../constants/pickerColors";

const LabelContainer = ({
  selectedLabels,
  onChangeEditLabelPanelVisibility,
  editPanelIsOpen,
}) => {
  const { labels: userLabels } = useSelector((state) => state.user);

  return (
    <div className="label-container">
      <div className="label-container_header">
        <Typography variant="body1" className="label-container_label-text">
          Labels
        </Typography>
        {!editPanelIsOpen ? (
          <EditButton onClick={() => onChangeEditLabelPanelVisibility(true)} />
        ) : (
          <CloseIcon
            className="label-container_close-panel-button"
            onClick={() => onChangeEditLabelPanelVisibility(false)}
          />
        )}
      </div>
      <div className="label-pill-container">
        {selectedLabels &&
          selectedLabels.map((selectedLabel) => {
            const label = userLabels[selectedLabel];
            if (!label) {
              return null;
            }
            return (
              <div
                className="label-pill"
                key={label.labelId}
                style={{ "--label-color": label.color || DEFAULT_LABEL_COLOR }}
                data-label-color={label.color || DEFAULT_LABEL_COLOR}
              >
                <Typography
                  variant="labelWhiteNoMargin"
                  className="label-pill__text"
                >
                  {label.name}
                </Typography>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default LabelContainer;
